export const timeout = (ms: number) =>{
    return new Promise (resolve => setTimeout(resolve, ms))
}

export const redirect = (url: string) =>{
    console.log(`redirecting to: ${url}`)
    window.location.href = url;
}
export const safeRedirect = (url: string) => {
    if (typeof window !== 'undefined') {
        window.location.href = url;
    } else {
        console.warn('Redirect attempted on server-side. URL:', url);
    }
};